<script lang="ts" setup>
import { ref, Ref, computed, watch } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';

import { MultiSelectOption, MeetingGetters, MeetingActions, MeetingFilter } from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';

const { t } = useI18n();

const filtersOpened = ref(false);

const filter: Ref<MeetingFilter> = ref({
    platform: null,
});

const storeFilters = computed<MeetingFilter>(() => store.getters[MeetingGetters.FILTER]);

const platformFilterOptions = [
    {
        label: t('meeting.filters.platform.google'),
        value: 'GOOGLE_MEET',
    },
] as MultiSelectOption[];

function applyFilters() {
    store.dispatch(MeetingActions.SET_FILTER, {
        platform: filter.value.platform,
    });
}

function clearFilters() {
    store.dispatch(MeetingActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    filter.value.platform = storeFilters.value.platform;
}

watch(filtersOpened, () => {
    refreshLocalFilter();
});
</script>

<template>
    <UiRightPanel v-model="filtersOpened" :title="$t('filter.sidebar.title')">
        <template #button>
            <UiButton
                size="md"
                variant="white"
                text-variant="gray-700"
                @click="filtersOpened = true"
            >
                <FilterIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true" />
                {{ $t('core.actions.Filter') }}
            </UiButton>
        </template>
        <template #default>
            <form autocomplete="off" class="flex flex-col gap-3">
                <div class="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6">
                    <div class="sm:col-span-3">
                        <label class="block text-sm font-medium text-gray-800">
                            {{ $t('meeting.filters.platform.label') }}
                        </label>
                        <UiMultiselect
                            name="filters_platform"
                            v-model="filter.platform"
                            primitive
                            can-clear
                            :options="platformFilterOptions"
                        />
                    </div>
                </div>
                <div class="mt-4 grid grid-cols-2 place-content-around gap-4 text-center">
                    <UiButton variant="white" text-variant="gray-700" @click="clearFilters()">
                        {{ $t('core.actions.Clear') }}
                    </UiButton>
                    <UiButton variant="primary" text-variant="white" @click="applyFilters()">
                        {{ $t('core.actions.Apply') }}
                    </UiButton>
                </div>
            </form>
        </template>
    </UiRightPanel>
</template>
